import React, { useState } from "react";

import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import LandingHeader from "../common/LandingHeader";
import LandingFooter from "../common/LandingFooter";

import './contact.css';

const ContactPage = () => {
  return (
    <div className="landing overflow-hidden">
      <section className="section heroSec heroSec--contact">

        <LandingHeader />

        <div className="container">
          <div className="hero-content">
            <form action="" className="contact__form">
              <h1 className="ff3">
                Get in touch
              </h1>

              <p className="sub-text">
                We are here to answer all your queries. Get in touch and the right team will get back to you in the next 48 hours.
              </p>

              <div className="row">
                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label htmlFor="firstName" className="label"> First Name <span className="red-asterisk">*</span></label>
                    <input
                      type="text" required
                      className="ff2 form-control"
                      placeholder="First Name"
                      name="firstName"
                    />
                  </div>
                </div>

                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label htmlFor="firstName" className="label"> Last Name <span className="red-asterisk">*</span></label>
                    <input
                      type="text" required
                      className="ff2 form-control"
                      placeholder="Last Name"
                      name="lastName"
                    />
                  </div>
                </div>

                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label htmlFor="firstName" className="label"> Email <span className="red-asterisk">*</span></label>
                    <input
                      type="email" required
                      className="ff2 form-control"
                      placeholder="abc@example.com"
                      name="email"
                    />
                  </div>
                </div>

                <div className="col-12 col-sm-6">
                  <div className="form-group">
                    <label htmlFor="firstName" className="label"> Phone Number <span className="red-asterisk">*</span></label>
                    <input
                      type="text" required
                      className="ff2 form-control"
                      placeholder="+91-00000000000"
                      name="phone"
                    />
                  </div>
                </div>

                <div className="col-12 col-sm-12">
                  <div className="form-group">
                    <label htmlFor="firstName" className="label"> Message <span className="red-asterisk">*</span></label>
                    <textarea
                      className="form-control"
                      rows="3"
                      placeholder="Write your message.."
                      name="message"
                    ></textarea>
                  </div>
                </div>

                <div className="col-12 col-sm-12">
                  <button type="submit" className="btn btn-solid btn-solid--cta">Send message</button>
                </div>
              </div>
            </form>
            <div className="w-100 hero-content__slider">
              <OwlCarousel
                className='w-100 position-relative'
                loop autoplay
                items={1}
                autoplayTimeout={3000}
                autoplaySpeed={300}
                autoplayHoverPause
              >
                <div className="bdrs40 w-100 item">
                  <div className="text-white item__top">
                    <div className="ff2 info">
                      <p className="fw700 fz22">
                        Support: <a className="link-light link-offset-2 link-underline-opacity-75 link-underline-opacity-100-hover" href="mailto:info@digilion.in">info@digilion.in</a> 
                      </p>
                      <p className="fw700 fz22">
                        Mobile: <a href="tel:9899648866">9899648866</a>
                      </p>
                    </div>
                    <div className="fz26 fw700 slide-num">
                      1/3
                    </div>
                  </div>
                  <div className="text-white bdrs20 item__bottom">
                    <div className="ff2 fw500 fz20 address">
                      <span>
                        <img src="./assets/images/landing/icon-location-marker.svg" alt="" />
                      </span>
                      <p>
                        132 Dartmouth Street Boston, Massachusetts
                        <br />
                        02156 United States
                      </p>
                    </div>
                    <div className="ff3 fw700 clock">11:11 PM</div>
                  </div>
                  <img src="./assets/images/landing/contact-hero.svg" alt="Hero Image 1" />
                </div>
                <div className="bdrs40 w-100 item">
                  <div className="text-white item__top">
                    <div className="ff2 info">
                      <p className="fw700 fz22">
                        Support: @jigyaasuai.com
                      </p>
                      <p className="fw700 fz22">
                        Mobile: +91 586 565 8884
                      </p>
                    </div>
                    <div className="fz26 fw700 slide-num">
                      2/3
                    </div>
                  </div>
                  <div className="text-white bdrs20 item__bottom">
                    <div className="ff2 fw500 fz20 address">
                      <span>
                        <img src="./assets/images/landing/icon-location-marker.svg" alt="" />
                      </span>
                      <p>
                        132 Dartmouth Street Boston, Massachusetts
                        <br />
                        02156 United States
                      </p>
                    </div>
                    <div className="ff3 fw700 clock">11:11 PM</div>
                  </div>
                  <img src="./assets/images/landing/contact-hero.svg" alt="Hero Image 1" />
                </div>
                <div className="bdrs40 w-100 item">
                  <div className="text-white item__top">
                    <div className="ff2 info">
                      <p className="fw700 fz22">
                        Support: @jigyaasuai.com
                      </p>
                      <p className="fw700 fz22">
                        Mobile: +91 586 565 8884
                      </p>
                    </div>
                    <div className="fz26 fw700 slide-num">
                      3/3
                    </div>
                  </div>
                  <div className="text-white bdrs20 item__bottom">
                    <div className="ff2 fw500 fz20 address">
                      <span>
                        <img src="./assets/images/landing/icon-location-marker.svg" alt="" />
                      </span>
                      <p>
                        132 Dartmouth Street Boston, Massachusetts
                        <br />
                        02156 United States
                      </p>
                    </div>
                    <div className="ff3 fw700 clock">11:11 PM</div>
                  </div>
                  <img src="./assets/images/landing/contact-hero.svg" alt="Hero Image 1" />
                </div> 
              </OwlCarousel>
            </div>
          </div>
        </div>
      </section>

      <LandingFooter />
    </div>
  );
};

export default ContactPage;
